var _circle, _g, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _g2, _rect13, _rect14, _path2, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiInitialitation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 165,
    viewBox: "0 0 150 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.0501,
    cy: 74.5408,
    r: 74.3313,
    fill: "url(#paint0_linear_834_19978)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_834_19978)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.543,
    y: 19.6003,
    width: 102.92,
    height: 128.775,
    rx: 5.98946,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.9173,
    y: 19.9747,
    width: 102.172,
    height: 128.026,
    rx: 5.61512,
    stroke: "#0869FB",
    strokeWidth: 0.748682
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.89,
    y: 63.7282,
    width: 92.2276,
    height: 58.4181,
    fill: "white",
    stroke: "#D2DAE6",
    strokeWidth: 0.748682,
    strokeDasharray: "2.25 2.25"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 66.3369,
    width: 87.0099,
    height: 53.2003,
    fill: "#87B7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8261 85.2305H90.6868C92.3449 85.2305 93.7005 86.5882 93.7005 88.2441V97.5873C93.7005 99.2432 92.3449 100.601 90.6868 100.601H76.8261C75.1681 100.601 73.8125 99.2432 73.8125 97.5873V88.2441C73.8125 86.5882 75.1681 85.2305 76.8261 85.2305ZM88.02 87.4425C88.8724 87.4425 89.5623 88.1324 89.5623 88.9848C89.5623 89.8371 88.8724 90.5292 88.02 90.5292C87.1677 90.5292 86.4756 89.8371 86.4756 88.9848C86.4756 88.1324 87.1677 87.4425 88.02 87.4425ZM78.08 95.8807L81.6212 90.1314C81.9175 89.7905 82.5892 89.7905 82.8855 90.1314L85.1849 93.8615L86.0961 92.3821C86.3071 92.1386 86.784 92.1386 86.9951 92.3821L89.5095 96.4651C89.9844 97.2363 89.4832 98.1819 88.643 98.1819H79.2977C78.1024 98.1819 77.4105 96.9664 78.08 95.8806V95.8807Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 103.641,
    y: 130.476,
    width: 23.8656,
    height: 9.94399,
    rx: 2.99473,
    fill: "#0869FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4961,
    y: 130.973,
    width: 44.748,
    height: 2.9832,
    fill: "#E3E8F0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4961,
    y: 138.431,
    width: 57.6751,
    height: 0.994399,
    fill: "#E3E8F0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4961,
    y: 136.442,
    width: 57.6751,
    height: 0.994399,
    fill: "#E3E8F0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.89,
    y: 24.9466,
    width: 92.2276,
    height: 30.0777,
    fill: "white",
    stroke: "#D2DAE6",
    strokeWidth: 0.748682,
    strokeDasharray: "2.25 2.25"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 27.5554,
    width: 87.0099,
    height: 9.44679,
    fill: "#E3E8F0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 38.4937,
    width: 62.6471,
    height: 2.9832,
    fill: "#E3E8F0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 45.4545,
    width: 87.0099,
    height: 0.994399,
    fill: "#E3E8F0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 48.4377,
    width: 87.0099,
    height: 0.994399,
    fill: "#E3E8F0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 51.4209,
    width: 87.0099,
    height: 0.994399,
    fill: "#E3E8F0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_834_19978)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.1445,
    y: 55.8959,
    width: 64.7722,
    height: 81.0435,
    rx: 3.90818,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3888,
    y: 56.1401,
    width: 64.2837,
    height: 80.555,
    rx: 3.66392,
    stroke: "#0869FB",
    strokeWidth: 0.488522
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5177,
    y: 83.676,
    width: 58.0255,
    height: 36.7477,
    fill: "white",
    stroke: "#D2DAE6",
    strokeWidth: 0.488522,
    strokeDasharray: "1.47 1.47"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1484,
    y: 85.3097,
    width: 54.7591,
    height: 33.4813,
    fill: "#87B7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0099 97.2012H50.733C51.7765 97.2012 52.6297 98.0556 52.6297 99.0978V104.978C52.6297 106.02 51.7765 106.874 50.733 106.874H42.0099C40.9664 106.874 40.1133 106.02 40.1133 104.978V99.0978C40.1133 98.0556 40.9664 97.2012 42.0099 97.2012ZM49.0547 98.5933C49.5911 98.5933 50.0253 99.0275 50.0253 99.5639C50.0253 100.1 49.5911 100.536 49.0547 100.536C48.5183 100.536 48.0827 100.1 48.0827 99.5639C48.0827 99.0275 48.5183 98.5933 49.0547 98.5933ZM42.799 103.904L45.0277 100.286C45.2141 100.071 45.6369 100.071 45.8233 100.286L47.2704 102.633L47.8439 101.702C47.9767 101.549 48.2768 101.549 48.4097 101.702L49.9921 104.272C50.291 104.757 49.9755 105.352 49.4468 105.352H43.5654C42.8131 105.352 42.3776 104.587 42.799 103.904V103.904Z",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 58.8906,
    y: 125.675,
    width: 15.0196,
    height: 6.25819,
    rx: 1.95409,
    fill: "#0869FB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1523,
    y: 125.988,
    width: 28.1618,
    height: 1.87746,
    fill: "#E3E8F0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1523,
    y: 130.681,
    width: 36.2975,
    height: 0.625819,
    fill: "#E3E8F0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1523,
    y: 129.43,
    width: 36.2975,
    height: 0.625819,
    fill: "#E3E8F0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5177,
    y: 59.27,
    width: 58.0255,
    height: 18.9119,
    fill: "white",
    stroke: "#D2DAE6",
    strokeWidth: 0.488522,
    strokeDasharray: "1.47 1.47"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1523,
    y: 60.903,
    width: 54.7591,
    height: 5.94528,
    fill: "#E3E8F0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1523,
    y: 67.7861,
    width: 39.4266,
    height: 1.87746,
    fill: "#E3E8F0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1523,
    y: 72.168,
    width: 54.7591,
    height: 0.625819,
    fill: "#E3E8F0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1523,
    y: 74.045,
    width: 54.7591,
    height: 0.625819,
    fill: "#E3E8F0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1523,
    y: 75.923,
    width: 54.7591,
    height: 0.625819,
    fill: "#E3E8F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_834_19978",
    x: 23.5588,
    y: 18.103,
    width: 120.89,
    height: 146.743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.48682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.49209
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.411765 0 0 0 0 0.984314 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_834_19978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_834_19978",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_834_19978",
    x: 8.28226,
    y: 54.9188,
    width: 76.498,
    height: 92.768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.88522
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.93113
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.411765 0 0 0 0 0.984314 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_834_19978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_834_19978",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_834_19978",
    x1: 75.0501,
    y1: 0.209473,
    x2: 74.8419,
    y2: 103.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiInitialitation);
export default __webpack_public_path__ + "static/media/AIInitialitation.e7852c8ac04d7f68759bc895a65a0a0a.svg";
export { ForwardRef as ReactComponent };